/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_Confirm_TextInputs */

const en_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will end your trial immediately and start your paid subscription. Are you sure?`)
};

const fr_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre période d'essai sera immédiatement interrompue et votre abonnement payant commencera. Êtes-vous sûr(e) ?`)
};

const de_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Damit endet Ihre Testphase sofort und Ihr kostenpflichtiges Abonnement beginnt. Sind Sie sicher?`)
};

const it_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo terminerà immediatamente la prova e inizierà l'abbonamento a pagamento. Sei sicuro?`)
};

const ru_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это немедленно завершит ваш пробный период и активирует платную подписку. Вы уверены?`)
};

const es_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto finalizará tu prueba inmediatamente y comenzará tu suscripción de pago. ¿Estás seguro?`)
};

const zh_cn2_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这将立即结束您的试用期并开始您的付费订阅。您确定吗？`)
};

const ja_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルは直ちに終了し、有料サブスクリプションが開始されます。よろしいですか？`)
};

const hi_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इससे आपका ट्रायल पीरियड तुरंत समाप्त हो जाएगा और आपकी पेड सब्सक्रिप्शन शुरू हो जाएगी। क्या आप निश्चित हैं?`)
};

const pt_pt2_activate_confirm_text = /** @type {(inputs: Activate_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso encerrará seu período de teste imediatamente e iniciará sua assinatura paga. Tem certeza?`)
};

/**
* | output |
* | --- |
* | "This will end your trial immediately and start your paid subscription. Are you sure?" |
*
* @param {Activate_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const activate_confirm_text = /** @type {((inputs?: Activate_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_activate_confirm_text(inputs)
	if (locale === "de") return de_activate_confirm_text(inputs)
	if (locale === "it") return it_activate_confirm_text(inputs)
	if (locale === "ru") return ru_activate_confirm_text(inputs)
	if (locale === "es") return es_activate_confirm_text(inputs)
	if (locale === "zh-CN") return zh_cn2_activate_confirm_text(inputs)
	if (locale === "ja") return ja_activate_confirm_text(inputs)
	if (locale === "hi") return hi_activate_confirm_text(inputs)
	if (locale === "pt-PT") return pt_pt2_activate_confirm_text(inputs)
	return en_activate_confirm_text(inputs)
});